// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ScheduledJobs_ListResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ScheduledJobs_ListResponse — GET /scheduled-jobs (full roster).
 *
 * Also reused, with a single-element `rows`, as the response of
 * POST /scheduled-jobs/save and POST /scheduled-jobs/toggle — both mutate
 * exactly one job and the console re-renders that one row from the fresh
 * DB state, so a second typed response shape would be pure duplication.
 */
import type { ScheduledJobs_JobRow } from './ScheduledJobs_JobRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface ScheduledJobs_ListResponseDados {
rows: ScheduledJobs_JobRow[]
}

export type ScheduledJobs_ListResponse = ApiResponse<ScheduledJobs_ListResponseDados>;

registerResponseContract('ScheduledJobs_ListResponse', {
  rows: {
    type: 'array',
    required: true,
    items: {
      id:               { type: 'number',  required: true },
      name:             { type: 'string',  required: false },
      job_type:         { type: 'string',  required: false },
      enabled:          { type: 'boolean', required: false },
      schedule_kind:    { type: 'string',  required: false },
      schedule_time:    { type: 'string',  required: false },
      interval_minutes: { type: 'number',  required: false },
      params:           { type: 'string',  required: false },
      channel:          { type: 'string',  required: false },
      channel_target:   { type: 'string',  required: false },
      max_attempts:     { type: 'number',  required: false },
      next_run_at:      { type: 'string',  required: false },
      last_run_at:      { type: 'string',  required: false },
      last_success_at:  { type: 'string',  required: false },
      created_at:       { type: 'string',  required: false },
      updated_at:       { type: 'string',  required: false },
      heartbeat_stale:  { type: 'boolean', required: false },
    },
  },
})
